import apiClient from '@/services/rest-api-sms/apiClient'

const baseEndpoint = '/dataset-invalid-reason'

export const get = async (queryParam) => {
  const params = {
    page: queryParam?.page || undefined,
    limit: queryParam?.limit || undefined,
    sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
    search: queryParam?.search || undefined,
    filters: queryParam?.filters || undefined,
  }

  const response = await apiClient({
    method: 'GET',
    url: `${baseEndpoint}`,
    params: params,
  })

  return response?.data
}

export const create = async (payload) => {
  const response = await apiClient({
    method: 'POST',
    url: baseEndpoint,
    data: payload,
  })

  return response?.data
}

export const update = async (id, payload) => {
  const response = await apiClient({
    method: 'PATCH',
    url: `${baseEndpoint}/${id}`,
    data: payload,
  })

  return response?.data
}

export const deleteById = async (id) => {
  const response = await apiClient({
    method: 'DELETE',
    url: `${baseEndpoint}/${id}`,
  })

  return response?.data
}

export const deleteBulk = async (ids) => {
  const response = await apiClient({
    method: 'DELETE',
    url: `${baseEndpoint}/bulk`,
    data: { ids },
  })

  return response?.data
}
